import { Component, Prop, State, Listen, Watch, h } from '@stencil/core';
import {
  MessageType
} from '../../conversational-search-types/conversational-search-types.type';
import { eventToMessageTypeMap, renderCorrectMessage } from './action-messages-helpers';
import type { labelProviderInterface } from '../../../../LabelProviderInterface';

@Component({
  tag: 'uiaas-search-conversational-search-action-messages',
  styleUrl: 'action-messages.scss',
  shadow: true,
})
export class ConversationalSearchActionMessages {
  @Prop() readonly labelProvider: labelProviderInterface;
  @Prop() readonly conversationalSearchMedaliaFormId: string;
  @Prop() readonly language: string;
  @Prop() readonly country: string;
  @Prop() readonly query: string;
  @Prop() readonly focusCallback: Function;

  @State() messageType: MessageType = MessageType.NONE;
  @State() isVisible = false;

  private messageTimeout: number;

  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  @Listen('conversational-search:context-changed', { target: 'window' })
  @Listen('conversational-search:cta-action', { target: 'window' })
  @Listen('conversational-search:user-new-conversation-trigger', { target: 'window' })
  @Listen('conversational-search:thumbs', { target: 'window' })
  @Listen('conversational-search:medalia-fallback', { target: 'window' })
  handleEvent(e: CustomEvent) {
      this.resetAllMessages();

      const messageType = eventToMessageTypeMap[e.type];
      if (typeof messageType === 'function') {
        this.messageType = messageType(e);
      } else {
        this.messageType = messageType;
      }

      if (this.messageType !== MessageType.NONE) {
        this.isVisible = true;
      }
  }

  private resetAllMessages() {
      this.setTimeoutClearHandler();
      this.isVisible = false;
      this.messageType = MessageType.NONE;
  }

  private setTimeoutHandler(timeoutValue: number) {
      this.messageTimeout = window.setTimeout(() => {
          this.isVisible = false;
      }, timeoutValue);
  }

  private setTimeoutClearHandler() {
      window.clearTimeout(this.messageTimeout);
  }

  disconnectedCallback() {
      if (this.messageTimeout) {
        this.setTimeoutClearHandler();
      }
  }

  @Watch('isVisible')
  handleVisibilityChange() {
      if (this.isVisible) {
        this.setTimeoutHandler(6000);
      } else if (this.messageType === MessageType.NEW_CONVERSATION) {
        this.focusCallback();
      }
  }

  render() {
      return this.isVisible ? (
        <section class='conversational-search-action-messages'>
          {renderCorrectMessage(this)}
        </section>
      ) : (
        ''
      );
  }
}
